import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PromoBar from "@/components/PromoBar";
import WeeklyThemeBanner from "@/components/WeeklyThemeBanner";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Instituto from "@/components/sections/Instituto";
import FinalCTA from "@/components/sections/FinalCTA";
import useDocumentMeta from "@/hooks/useDocumentMeta";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "NGO",
  name: "Instituto Garoto da Arena",
  description:
    "Ação social do Ministério Carlos Medeiros. Atende famílias em Jaboatão dos Guararapes com esporte, terapias integradas e cuidado espiritual.",
  areaServed: "Jaboatão dos Guararapes, PE, Brasil",
  url: "https://institutogaa.com.br",
};

export default function InstitutoPage() {
  useDocumentMeta({
    title: "Instituto Garoto da Arena, Ação Social do Ministério",
    description:
      "Conheça o Instituto Garoto da Arena. Cuidado integral de crianças, jovens e famílias em vulnerabilidade em Jaboatão dos Guararapes.",
    canonical: "https://cemedeiros.com.br/instituto",
    url: "https://cemedeiros.com.br/instituto",
    jsonLd: JSON_LD,
  });
  return (
    <div data-testid="instituto-page" className="bg-[#0B1E36] min-h-screen">
      <PromoBar />
      <WeeklyThemeBanner mode="top" />
      <Navbar />
      <main className="pt-32">
        <Instituto />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
